import { useObjectTypeSelect } from '../../../hooks/useObjectTypeSelect';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { Select } from 'foundations-components/transitional/components/Select';
import { useEditorActions } from '../../../hooks/useEditorActions';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ObjectSelect = () => {
  const {
    defaultValue,
    filteringObjectDropdownLabel,
    hasOnlyOneOption,
    itemComponent,
    options,
    value,
    onChange: onObjectTypeSelectChange
  } = useObjectTypeSelect({
    getSelectedOptionAssociatedObjectText: objectType => I18n.text('customerDataFiltersUI.objectTypeSelect.options.associated', {
      objectType
    }),
    getSelectedOptionCurrentObjectText: objectType => I18n.text('customerDataFiltersUI.objectTypeSelect.options.primary', {
      objectType
    }),
    usePluralObjectNames: true
  });
  const {
    setCategory
  } = useEditorActions();
  if (hasOnlyOneOption) {
    return null;
  }
  return /*#__PURE__*/_jsxs(Flex, {
    paddingInlineStart: "400",
    paddingInlineEnd: "400",
    paddingBlockStart: "400",
    alignItems: "baseline",
    children: [/*#__PURE__*/_jsx(View, {
      paddingInlineEnd: "200",
      as: "div",
      children: filteringObjectDropdownLabel || /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "customerDataFiltersUI.objectTypeSelect.viewing"
      })
    }), /*#__PURE__*/_jsx(Select, {
      defaultValue: defaultValue,
      itemComponent: itemComponent,
      onChange: event => {
        onObjectTypeSelectChange(event);
        setCategory(undefined);
      },
      options: options,
      readOnly: hasOnlyOneOption,
      value: value,
      buttonUse: "transparent",
      menuWidth: "auto"
    })]
  });
};
export default ObjectSelect;